import React from 'react'
import { RequestInquiryDetailView } from '../../views'
import { LocalStorageService } from '../../../services/index'

class RequestInquiryDetailAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
  }

  token = {}
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()


  async componentDidMount() {
    // this.setState({ loading: true })
    this.token = this.localStorageService.getLocalStorageItem('token').idToken

  }
  
  scrollWindow = () => {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <RequestInquiryDetailView
        {...this.state}
      />
    )
  }
}


export { RequestInquiryDetailAction as default }
